export default __webpack_public_path__ + "static/media/heimdallr-white.9bb93eba.svg";